export let productionCapacityListProps = {
    sl_no: 0,
    id: 0,
    store_id: null,
    capacity_per_day: 0
}

export let dataProps = {
    category_id: null, 
    capacity_list: [JSON.parse(JSON.stringify(productionCapacityListProps))],
    deleted_capacity_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/productionCapacity/properties.js